import { useState } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { axios } from '#api/axios';
import CommunityTag from '../community/ArticlePage/Tag';
import TmmunityHeader from './Header';
import CommunityFeeds from '../community/ArticlePage/feed';
import WriteButton from '../community/WriteButton';
import { paramsSetter } from 'src/refactor_shared/lib/paramSetter';
import useObserver from 'src/refactor_shared/hooks/useObserver';
import { Modal } from '#molecules';
import ColumnModal from './ColumnModal';
import { useNavigate } from 'react-router';
import { useGetMyAccount } from '#api/accounts';

export type ThreadType = {
  id: string;
  gyms?: { id: string; name: string }[];
  writerId: string;
  category: string;
  sequence: number;
  title: string;
  createdAt: string;
  image: string | null;
  name: string;
  startAthletic: string;
  answerCount?: number;
};

const TrainerCommunity = () => {
  const [tag, setTag] = useState('ALL'); // PARSE_CATEGORY의 value가 들어옴
  const [searchData, setSearchData] = useState('');
  const [columnModalOpen, setColumnModalOpen] = useState(false);
  const { data } = useGetMyAccount(true);

  const {
    data: threadGroup,
    fetchNextPage,
    hasNextPage
  } = useInfiniteQuery({
    queryKey: ['get-infinite-trainer-community', searchData, tag],
    queryFn: async ({ pageParam: lastId = 0 }) => {
      const params = paramsSetter(searchData, tag);

      const response = await axios.get<Array<ThreadType>>(
        `/trainers/questions?${params.toString()}`,
        {
          params: {
            limit: 10,
            lastId: lastId
          }
        }
      );
      return response.data;
    },
    getNextPageParam: lastPage => lastPage[lastPage.length - 1]?.sequence
  });

  const [targetRef] = useObserver(fetchNextPage, hasNextPage);
  const navigate = useNavigate();

  const handleRoutingNavigate = () => {
    if (data?.hasWriteColumnPermission === false && tag === '칼럼') {
      setColumnModalOpen(true);
    } else if (tag !== 'ALL') {
      navigate(`/trainer-community/write?tag=${tag}`);
    } else {
      navigate(`/trainer-community/write`);
    }
  };

  return (
    <>
      <TmmunityHeader searchData={searchData} setSearchData={setSearchData} />
      <div className="flex flex-col px-20 pb-20">
        <CommunityTag
          tag={tag}
          setTag={setTag}
          targetValue="trainer-community"
        />
        {threadGroup?.pages ? (
          <div className="pb-50">
            <div className="flex flex-col">
              {threadGroup?.pages.map((threads, index) => (
                <div key={index}>
                  {threads.map(thread => (
                    <CommunityFeeds<ThreadType>
                      key={thread.id}
                      to={`/trainer-community/${thread.id}`}
                      thread={thread}
                    />
                  ))}
                </div>
              ))}
            </div>
            <div
              ref={targetRef}
              className="absolute bottom-0 left-0 w-full py-20 h-50"
            />
          </div>
        ) : null}
        <WriteButton onClick={() => handleRoutingNavigate()} />
      </div>
      {columnModalOpen && (
        <Modal
          onClose={() => setColumnModalOpen(false)}
          style={{ maxWidth: '335px', padding: '24px' }}
        >
          <ColumnModal setColumnModalOpen={setColumnModalOpen} />
        </Modal>
      )}
    </>
  );
};

export default TrainerCommunity;
